angular.module('aprima-provider-api').factory(
    'MessageRepository', ['AprimaRestangular', 'CurrentUser', '$q', 'Bridge', 'MetadataRepository', 'AprimaAnalytics',
        function (Restangular, CurrentUser, $q, Bridge, MetadataRepository, AprimaAnalytics) {

            'use strict';

            var messageListeners = [];

            function getAll(messageFilterId, restangularOptions, appComponent) {
                restangularOptions = restangularOptions || { ignoreCache: false };
                var timing = AprimaAnalytics.startTiming(appComponent || 'MessageRepository', 'api', 'getMessages');
                return Restangular.get(restangularOptions).all('users/' + CurrentUser.get().userId + '/messages')
                    .getList({
                        filterId: messageFilterId
                    })
                    .finally(timing.stop);
            }

            function getDashboardMessages(messageFilterId) {
                if (messageFilterId) {
                    return getAll(messageFilterId);
                }
                else {
                    return $q.when([]);
                }
            }

            function addListener(callback) {
                if (messageListeners && callback && messageListeners.indexOf(callback) < 0) {
                    messageListeners.push(callback);
                }
            }

            function removeListener(callback) {
                if (messageListeners && callback && messageListeners.indexOf(callback) >= 0) {
                    messageListeners.pop(callback);
                }
            }

            function getMessage(messageId, appComponent) {
                var timing = AprimaAnalytics.startTiming(appComponent || 'MessageRepository', 'api', 'getMessage');
                return Restangular.get().one('messages/' + messageId).get()
                    .then(function (m) {
                        Bridge.updateBadges();
                        return m;
                    })
                    .finally(timing.stop);
            }

            function emitUpdateMessage() {
                if (messageListeners) {
                    for (var i = messageListeners.length - 1; i >= 0; i--) {
                        messageListeners[i]();
                    }
                }
            }

            function savePhoneMessage(message, appComponent) {
                var timing = AprimaAnalytics.startTiming(appComponent || 'MessageRepository', 'api', 'savePhoneMessage');
                return Restangular.get().one('messages').customPUT(message, 'phone/' + message.Id, {}, {})
                    .then(function (data) {
                        emitUpdateMessage();
                        return data;
                    })
                    .finally(timing.stop);
            }

            function saveTaskMessage(message, appComponent) {
                var timing = AprimaAnalytics.startTiming(appComponent || 'MessageRepository', 'api', 'saveTaskMessage');
                return Restangular.get().one('messages').customPUT(message, 'task/' + message.Id, {}, {})
                    .then(function (data) {
                        emitUpdateMessage();
                        return data;
                    })
                    .finally(timing.stop);
            }

            function savePortalMessage(message, appComponent) {
                var timing = AprimaAnalytics.startTiming(appComponent || 'MessageRepository', 'api', 'saveTaskMessage');
                return Restangular.get().one('messages').customPUT(message, 'portal/' + message.Id, {}, {})
                    .then(function (data) {
                        emitUpdateMessage();
                        return data;
                    })
                    .finally(timing.stop);
            }

            function saveAttachmentApprovalMessage(command, appComponent) {
                var timing = AprimaAnalytics.startTiming(appComponent || 'MessageRepository', 'api', 'saveAAMessage');
                var restangular = Restangular.get();

                var messagePromise = restangular.one('messages').customPUT(command, 'aamessage/' + command.Id, {}, {})
                    .then(function (data) {
                        emitUpdateMessage();
                        return data;
                    })
                    .finally(timing.stop);

                return messagePromise;
            }

            function replyToPortalMessage(message, appComponent) {
                var timing = AprimaAnalytics.startTiming(appComponent || 'MessageRepository', 'api', 'replyToPortalMessage');
                return Restangular.get().one('messages').customPUT(message, 'portal/' + message.Id + '/reply', {}, {})
                    .then(function (data) {
                        emitUpdateMessage();
                        return data;
                    })
                    .finally(timing.stop);
            }

            function getPhoneMessageDetails(messageId, appComponent) {
                var timing = AprimaAnalytics.startTiming(appComponent || 'MessageRepository', 'api', 'getPhoneMessage');
                var restangular = Restangular.get(),
                    messagePromise = restangular.one('messages/phone/' + messageId).get()
                        .then(function (m) {
                            Bridge.updateBadges();
                            return m;
                        })
                        .finally(timing.stop);

                return messagePromise;
            }

            function getTaskMessageDetails(messageId, appComponent) {
                var timing = AprimaAnalytics.startTiming(appComponent || 'MessageRepository', 'api', 'getTaskMessage');
                var restangular = Restangular.get(),
                    messagePromise = restangular.one('messages/task/' + messageId).get()
                        .then(function (m) {
                            Bridge.updateBadges();
                            return m;
                        })
                        .finally(timing.stop);

                return messagePromise;
            }

            function getPortalMessageDetails(messageId, appComponent) {
                var timing = AprimaAnalytics.startTiming(appComponent || 'MessageRepository', 'api', 'getPortalMessage');
                var restangular = Restangular.get(),
                    messagePromise = restangular.one('messages/portal/' + messageId).get()
                        .then(function (m) {
                            Bridge.updateBadges();
                            emitUpdateMessage();
                            return m;
                        })
                        .finally(timing.stop);

                return messagePromise;
            }

            function getRxRefillMessage(messageId, appComponent) {
                var timing = AprimaAnalytics.startTiming(appComponent || 'MessageRepository', 'api', 'getRxRefillMessage');
                var restangular = Restangular.get(),
                    messagePromise = restangular.one('messages/rx-refill/' + messageId).get()
                        .then(function (m) {
                            Bridge.updateBadges();
                            emitUpdateMessage();
                            return m;
                        })
                        .finally(timing.stop);

                return messagePromise;
            }

            function saveRxRefillMessage(message, appComponent) {
                var timing = AprimaAnalytics.startTiming(appComponent || 'MessageRepository', 'api', 'saveRxRefillMessage');
                return Restangular.get().one('messages').customPUT(message, 'rx-refill/' + message.Id, {}, {})
                    .then(function (data) {
                        emitUpdateMessage();
                        return data;
                    })
                    .finally(timing.stop);
            }

            function getRxRefillMessageV2(messageId, appComponent) {
                var timing = AprimaAnalytics.startTiming(appComponent || 'MessageRepository', 'api', 'getRxRefillMessageV2');
                var restangular = Restangular.get(),
                    messagePromise = restangular.one('messages/rx-refill-v2/' + messageId).get()
                        .then(function (m) {
                            Bridge.updateBadges();
                            emitUpdateMessage();
                            return m;
                        })
                        .finally(timing.stop);

                return messagePromise;
            }

            function saveRxRefillMessageV2(message, appComponent) {
                var timing = AprimaAnalytics.startTiming(appComponent || 'MessageRepository', 'api', 'saveRxRefillMessageV2');
                return Restangular.get().one('messages').customPUT(message, 'rx-refill-v2', {}, {})
                    .then(function (data) {
                        emitUpdateMessage();
                        return data;
                    })
                    .finally(timing.stop);
            }

            function getPharmacyRefillMessage(messageId, appComponent) {
                var timing = AprimaAnalytics.startTiming(appComponent || 'MessageRepository', 'api', 'getPharmacyRefillMessage');
                var restangular = Restangular.get(),
                    messagePromise = restangular.one('messages/pharmacy-refill/' + messageId).get()
                        .then(function (m) {
                            Bridge.updateBadges();
                            emitUpdateMessage();
                            m = mapToFullERxRequest(m);
                            return m;
                        })
                        .finally(timing.stop);

                return messagePromise;
            }

            // creates the new data structure with legacy data
            function mapToFullERxRequest(msg) {
                var request = msg && msg.RefillRequest;
                if(!request) {
                    return msg;
                }

                if(!request.hasOwnProperty('PrescribedMedication')) {
                    request.PrescribedMedication = {
                        Comment: request.MedicationComment,
                        Date: request.MedicationDate,
                        // the duration was previously mapped to the date for some reason
                        Duration: request.MedicationDate,
                        Name: request.MedicationName,
                        ProductCode: request.MedicationNdc,
                        ProductCodeDescription: request.MedicationNdc ? request.MedicationNdc + ' (NDC)' : null,
                        PotencyUnitCode: request.MedicationPotencyUnitCode,
                        Quantity: request.MedicationQuantity,
                        QuantityQualifierTerm: request.MedicationQuantityQualifier,
                        Sig: request.MedicationSig,
                        Strength: request.MedicationStrength,
                        StrengthUnits: request.MedicationStrengthUnits,
                    };
                }

                return msg;
            }

            function savePharmacyRefillMessage(message, appComponent) {
                var timing = AprimaAnalytics.startTiming(appComponent || 'MessageRepository', 'api', 'savePharmacyRefillMessage');
                return Restangular.get().one('messages').customPUT(message, 'pharmacy-refill/' + message.Id, {}, {})
                    .then(function (data) {
                        emitUpdateMessage();
                        return data;
                    })
                    .finally(timing.stop);
            }

            function getPharmacyRefillMessageMetadata($scope) {
                var timing = AprimaAnalytics.startTiming('MessageRepository', 'api', 'getPharmacyRefillMessageMetadata');
                return MetadataRepository.getMetadata('pharmacyrefillmessage', $scope).finally(timing.stop);
            }

            function createTaskMessage(message) {
                var timing = AprimaAnalytics.startTiming('MessageRepository', 'api', 'createTaskMessage');
                var restangular = Restangular.get();
                return restangular.all('messages/task/').post(message).finally(timing.stop);
            }

            function getTaskMessageMetadata($scope) {
                var timing = AprimaAnalytics.startTiming('MessageRepository', 'api', 'getCreateTaskMessageMetadata');
                return MetadataRepository.getMetadata('createtaskmessage', $scope).finally(timing.stop);
            }

            function createPortalMessage(message) {
                var timing = AprimaAnalytics.startTiming('MessageRepository', 'api', 'createPortalMessage');
                var restangular = Restangular.get();
                return restangular.all('messages/portal/').post(message).finally(timing.stop);
            }

            function getPatientPortalMessageRoutingType() {
                var timing = AprimaAnalytics.startTiming('MessageRepository', 'api', 'getPatientPortalMessageRoutingType');
                var restangular = Restangular.get();
                return restangular.one('messages/patientportal/routingtype').get().finally(timing.stop);
            }

            function getPortalMessageMetadata($scope) {
                var timing = AprimaAnalytics.startTiming('MessageRepository', 'api', 'getCreatePortalMessageMetadata');
                return MetadataRepository.getMetadata('createportalmessage', $scope).finally(timing.stop);
            }

            function createPhoneMessage(message) {
                var timing = AprimaAnalytics.startTiming('MessageRepository', 'api', 'createPhoneMessage');
                var restangular = Restangular.get();
                return restangular.all('messages/phone/').post(message).finally(timing.stop);
            }

            function getPhoneMessageMetadata($scope) {
                var timing = AprimaAnalytics.startTiming('MessageRepository', 'api', 'getPortalMessageMetadata');
                return MetadataRepository.getMetadata('createphonemessage', $scope).finally(timing.stop);
            }

            function getAttachmentApprovalMessage(messageId, appComponent) {
                var timing = AprimaAnalytics.startTiming(appComponent || 'MessageRepository', 'api', 'getAAMessage');

                var restangular = Restangular.get(),
                    messagePromise = restangular.one('messages/aamessage', messageId).get()
                        .then(function (m) {
                            Bridge.updateBadges();
                            return m;
                        })
                        .finally(timing.stop);

                return messagePromise;

            }

            function getServiceOrderApprovalMessage(messageId, appComponent) {
                var timing = AprimaAnalytics.startTiming(appComponent || 'MessageRepository', 'api', 'getServiceOrderApprovalMessage');

                var restangular = Restangular.get();

                var messagePromise = restangular.one('messages/serviceorderapprovalmessage', messageId).get()
                    .then(function (data) {
                        Bridge.updateBadges();
                        return data;
                    })
                    .finally(timing.stop);

                return messagePromise;
            }


            function saveServiceOrderApprovalMessage(message, appComponent) {
                var timing = AprimaAnalytics.startTiming(appComponent || 'MessageRepository', 'api', 'saveServiceOrderApprovalMessage');
                var restangular = Restangular.get();
                var messagePromise = restangular.one('messages').customPUT(message, 'serviceorderapprovalmessage/' + message.Id, {}, {})
                    .then(function (data) {
                        emitUpdateMessage();
                        return data;
                    })
                    .finally(timing.stop);

                return messagePromise;
            }


            return {
                getAll: getAll,
                getDashboardMessages: getDashboardMessages,
                getMessage: getMessage,
                savePhoneMessage: savePhoneMessage,
                saveTaskMessage: saveTaskMessage,
                savePortalMessage: savePortalMessage,
                replyToPortalMessage: replyToPortalMessage,
                getPhoneMessageDetails: getPhoneMessageDetails,
                getTaskMessageDetails: getTaskMessageDetails,
                getPortalMessageDetails: getPortalMessageDetails,
                createTaskMessage: createTaskMessage,
                getTaskMessageMetadata: getTaskMessageMetadata,
                createPhoneMessage: createPhoneMessage,
                getPhoneMessageMetadata: getPhoneMessageMetadata,
                addListener: addListener,
                removeListener: removeListener,
                createPortalMessage: createPortalMessage,
                getPortalMessageMetadata: getPortalMessageMetadata,
                getAttachmentApprovalMessage: getAttachmentApprovalMessage,
                saveAttachmentApprovalMessage: saveAttachmentApprovalMessage,
                getServiceOrderApprovalMessage: getServiceOrderApprovalMessage,
                saveServiceOrderApprovalMessage: saveServiceOrderApprovalMessage,
                getRxRefillMessage: getRxRefillMessage,
                saveRxRefillMessage: saveRxRefillMessage,
                getRxRefillMessageV2: getRxRefillMessageV2,
                saveRxRefillMessageV2: saveRxRefillMessageV2,
                getPharmacyRefillMessage: getPharmacyRefillMessage,
                savePharmacyRefillMessage: savePharmacyRefillMessage,
                getPharmacyRefillMessageMetadata: getPharmacyRefillMessageMetadata,
                getPatientPortalMessageRoutingType: getPatientPortalMessageRoutingType
            };
        }]);
